import { useQuery } from '@tanstack/react-query'
import { anyRunToFollow } from '@/features/documents/extraction-progress'
import { caseKeys } from '@/hooks/use-case-queries'
import { api } from '@/services/api'

/**
 * The newest extraction runs of a case, read again every `pollMs` for as long as a run is going
 * that is young enough to follow: a run that is stuck keeps no page asking for ever. The one
 * read of the runs for the documents page and the runs page, which differ only in their pace.
 */
export function useExtractionRuns(caseId: string, pollMs: number) {
  return useQuery({
    queryKey: caseKeys.extractionRuns(caseId),
    queryFn: () => api.cases.getExtractionRuns(caseId),
    refetchInterval: query => (anyRunToFollow(query.state.data, Date.now()) ? pollMs : false),
  })
}
